export default {
  // Lista de formulários
  forms: [],
  pagination: {},

  // Formulário atual sendo editado
  form: null,

  // Campos do formulário atual
  fields: [],

  // Campo selecionado para edição
  selectedField: null,

  // Condições do formulário atual
  conditions: [],

  // Tipos de campos disponíveis
  fieldTypes: [],
  fieldTypesGrouped: [],

  // Operadores e ações de condicionais
  operators: [],
  actions: [],

  // Estado do builder
  isDirty: false,
  isLoading: false
}
